module.exports = __webpack_public_path__ + "media/images/icons/question-mark-3ca3046334ced6bbc45680f7c6083185.svg";